import * as React from 'react';

interface Shell {
  /** Open the presence-pill menu: duty status and settings. */
  openMenu: () => void;
}

export const ShellContext = React.createContext<Shell>({ openMenu: () => {} });

export const useShell = () => React.useContext(ShellContext);
